import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Textarea } from 'primeng/textarea';
import { CmsDevAuthService } from '../cms-auth/cms-dev-auth.service';
@Component({
  selector: 'lib-cms-dev-login',
  standalone: true,
  imports: [FormsModule, Button, Textarea],
  templateUrl: './cms-dev-login.html',
  styleUrl: './cms-dev-login.scss'
})
export class CmsDevLoginComponent {
  private readonly devAuth = inject(CmsDevAuthService);
  tokenInput = '';
  error = '';
  onSave(): void {
    const trimmed = this.tokenInput.trim();
    if (!trimmed) {
      this.error = 'Paste a valid Cognito access token.';
      return;
    }
    this.devAuth.setToken(trimmed);
    this.tokenInput = '';
    this.error = '';
  }
}
